<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
// Make Octane consent checkbox visible + prechecked on /pages/product-quiz
(function () {
  if (!document.body.classList.contains('page-product-quiz')) return;

  function fix() {
    var boxes = document.querySelectorAll(
      '.octane-ai-quiz input[type="checkbox"], .octane-ai-embed input[type="checkbox"]'
    );
    boxes.forEach(function (cb) {
      cb.style.visibility = 'visible';
      cb.style.opacity = '1';
      cb.style.display = 'inline-block';
      cb.style.position = 'static';
      cb.style.clip = 'auto';
      cb.style.transform = 'none';
      cb.checked = true; // pre-check
    });
  }

  document.addEventListener('DOMContentLoaded', fix);
  new MutationObserver(fix).observe(document.documentElement, { childList: true, subtree: true });
})();
